module.exports = __webpack_public_path__ + "img/cadreNormal.00ad2c9e.png";